// /**
//  * User - Assign
//  */

// React
import React, {useEffect} from 'react';

// react hook form
import {useForm} from 'react-hook-form';

// UI
import {Grid, Button, FormControl, InputLabel, Select} from '@material-ui/core';

// Type
// import {Partner} from '../../partners/interfaces';

type Props = {
  data: any;
  centers: any;
  partners: any;
  centersDispatch: any;
  partnersDispatch: any;
};

type Inputs = {
  name: String;
  phoneNumber: String;
  emailAddress: String;
  password: string;
  password_repeat: string;
};

export default function Assign(props: Props) {
  useEffect(() => {
    props.centersDispatch({});
    props.partnersDispatch({});
  }, [props]);
  const {register, handleSubmit, errors} = useForm<Inputs>();

  const onSubmit = (data: any) => {
    // const {name, password, phoneNumber, emailAddress} = data;
    // const {id, status} = props.data;
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={5} alignItems="flex-start">
        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <Grid item xs={6}>
            <FormControl style={{width: '100%'}}>
              <InputLabel id="role-lable">نام شرکت</InputLabel>
              <Select
                native
                fullWidth
                labelId="role-lable"
                id="role"
                name="role"
                inputRef={register}
                error={errors.emailAddress && true}
              >
                <option value={''}></option>
                {props.partners.map((partner: any) => (
                  <option value={partner.id} key={partner.id}>
                    {partner.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <FormControl style={{width: '100%'}}>
              <InputLabel id="role-lable">مرکز شرکت انتخاب شده</InputLabel>
              <Select
                native
                fullWidth
                labelId="role-lable"
                id="role"
                name="role"
                inputRef={register}
                error={errors.emailAddress && true}
              >
                <option value={''}></option>
                {props.centers.map((center: any) => (
                  <option value={center.id} key={center.id}>
                    {center.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid
          container
          item
          xs={4}
          spacing={1}
          alignItems="flex-end"
          style={{marginTop: 'auto', marginRight: 'auto'}}
        >
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            data-cy="search"
          >
            {`اختصاص دادن`}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
